import axios from 'axios';
import PropTypes from 'prop-types';
import React from 'react';
import Yup from 'yup';
import ModalAbstraction from '../../CallToAction/LeftRailCTA/ModalAbstraction/ModalAbstraction';
import PopUp from '../../Elements/PopUp/PopUp';
import BasicDropdown from '../../Input/BasicDropdown/BasicDropdown';
import Button from '../../Input/Button/Button';
import InputField from '../../Input/InputField/InputField';

import './SalaryTipModal.scss';

const schemas = {
    companyId: Yup.number().required(),
    title: Yup.string().nullable().max(255),
    department: Yup.string().nullable().max(255),
    salary: Yup.number().nullable().required(),
    bonus: Yup.number().nullable().required(),
    gender: Yup.string().nullable().required().oneOf(['female', 'male']),
    atLeastTitleOrDepartment: Yup.mixed().when(['title', 'department'], {
        is: (title, department) => !title && !department,
        then: Yup.string().test(
            'at-least-one',
            'Please fill out either title or department, or both.',
            () => false
        ),
        otherwise: Yup.string().test(
            'at-least-one',
            'Please fill out either title or department, or both.',
            () => true
        ),
    }),
};

export default class SalaryTipModal extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            title: null,
            department: null,
            salary: null,
            bonus: null,
            gender: 'female',
            errors: {
                title: null,
                department: null,
                salary: null,
                bonus: null,
                gender: null,
            },
            generalError: null,
            showPopUp: false,
            popUpMessage: null,
        };
    }

    static propTypes = {
        companyId: PropTypes.number.isRequired,
        companyName: PropTypes.string.isRequired,
        onClose: PropTypes.func.isRequired,
        showModal: PropTypes.bool.isRequired,
    };

    static defaultProps = {};

    _validateInput = async (type, value) => {
        try {
            await schemas[type].validate(value);
            return true;
        } catch (e) {
            const errors = { ...this.state.errors };
            errors[type] = e.message;
            this.setState({
                errors,
            });
            return false;
        }
    };

    handleInputChange = (type) => (value) => {
        const newState = { ...this.state };
        const newValue = value || null;
        newState[type] = newValue;
        newState.errors[type] = null;
        newState.generalError = null;
        this.setState(newState, () => this._validateInput(type, newValue));
    };

    onSubmitTipForm = async () => {
        try {
            await axios.post('/api/company/submit-salary-tip', {
                companyId: this.props.companyId,
                title: this.state.title || null,
                department: this.state.department || null,
                salary: this.state.salary,
                bonus: this.state.bonus,
                gender: this.state.gender,
            });

            this.setState({
                showPopUp: true,
                popUpMessage:
                    "Thanks for the tip. We'll review and post content that meets guidelines shortly.",
            });
        } catch (e) {
            const errors = e.response.data.errors;
            const errorMessage = errors[Object.keys(errors)[0]];

            this.setState({
                showPopUp: true,
                popUpMessage: errorMessage,
            });
        }
    };

    renderTipField = (fileName, inputType, placeholder) => {
        return (
            <div className="input-tip-section">
                <InputField
                    name={fileName}
                    type={inputType}
                    qaDataAttr={fileName}
                    onChange={this.handleInputChange(fileName)}
                    onBlur={() =>
                        this._validateInput(fileName, this.state[fileName])
                    }
                    value={this.state[fileName]}
                    placeholder={placeholder}
                />
                <div className="errorMessage">
                    {this.state.errors[fileName]}
                </div>
            </div>
        );
    };

    renderInputFields = () => {
        return (
            <React.Fragment>
                <label>
                    Please provide your title and/or department (only one
                    required)*
                </label>
                {this.renderTipField('title', 'text', 'Title')}
                <div className={'text-center'}>~ or ~</div>
                {this.renderTipField('department', 'text', 'Department')}
                {this.renderTipField(
                    'salary',
                    'number',
                    'Please enter numbers only for Salary *'
                )}
                {this.renderTipField(
                    'bonus',
                    'number',
                    'Please enter numbers only for bonus *'
                )}
            </React.Fragment>
        );
    };

    renderForm = () => {
        const {
            title,
            department,
            salary,
            bonus,
            gender,
            errors,
            generalError,
        } = this.state;
        let noErrors = true,
            submitButtonDisabled = true;
        if (generalError) {
            noErrors = false;
        }
        for (let type in errors) {
            if (errors[type]) {
                noErrors = false;
                break;
            }
        }

        if (noErrors && (title || department) && salary && bonus && gender) {
            submitButtonDisabled = false;
        }

        return (
            <div className={'tip-form'}>
                <form>
                    {this.renderInputFields()}
                    <div className="p-2">
                        <BasicDropdown
                            options={[
                                {
                                    label: 'female',
                                    value: 'female',
                                },
                                {
                                    label: 'male',
                                    value: 'male',
                                },
                            ]}
                            onChange={this.handleInputChange('gender')}
                            selectedValue={this.state.gender}
                        />
                    </div>
                </form>
                <div className="submit-button-div">
                    <Button
                        disabled={submitButtonDisabled}
                        type={'solid'}
                        value={'Add a tip'}
                        onClick={this.onSubmitTipForm}
                    />
                </div>
            </div>
        );
    };

    render() {
        return (
            <div className="component-Employer-SalaryTipModal ">
                <ModalAbstraction
                    showModal={this.props.showModal}
                    onClose={this.props.onClose}
                    allowScroll={false}
                    showButton={false}
                    title={`ADD A TIP FOR ${this.props.companyName.toUpperCase()}!`}
                >
                    {this.renderForm()}
                </ModalAbstraction>
                <PopUp
                    showPopUp={this.state.showPopUp}
                    showOverlay={true}
                    close={() => this.setState({ showPopUp: false })}
                    cancel={() => this.setState({ showPopUp: false })}
                    buttonText={'Continue'}
                    minHeight={'300px'}
                    minWidth={'320px'}
                    maxHeight={'300px'}
                    maxWidth={'320px'}
                >
                    <p>{this.state.popUpMessage}</p>
                </PopUp>
            </div>
        );
    }
}
